import React, { useEffect } from 'react';
import { TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch';

interface ImageZoomModalProps {
  isOpen: boolean;
  imageSrc: string;
  onClose: () => void;
}

export const ImageZoomModal: React.FC<ImageZoomModalProps> = ({ isOpen, imageSrc, onClose }) => {
  useEffect(() => {
    if (!isOpen) {
      return;
    }

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onClose]);

  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-90 flex justify-center z-50 p-8 overflow-y-auto">
      <button
        onClick={onClose}
        className="fixed top-4 right-4 text-white bg-black bg-opacity-50 rounded-full p-2 hover:bg-opacity-75 z-50"
      >
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>
      <div className="w-full h-full flex items-center justify-center">
        <TransformWrapper
          wheel={{ step: 0.2 }}
          doubleClick={{ mode: 'reset' }}
          pinch={{ step: 5 }}
          limitToBounds={false}
          centerOnInit={true}
          minScale={1}
          maxScale={5}
        >
          <TransformComponent
            wrapperStyle={{ width: '100%', height: '100%', overflow: 'visible' }}
            contentStyle={{
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <img
              src={imageSrc}
              alt="Product (Zoomed)"
              className="max-w-full max-h-[calc(100vh-4rem)] object-contain"
            />
          </TransformComponent>
        </TransformWrapper>
      </div>
    </div>
  );
};
